'use client';
const focussableElements = `a:not([disabled]):not([tabindex="-1"]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])`;
export const moveFocus = (element, focusPrevious = false, isCyclic = false) => {
    if (!element)
        return;
    const focussable = Array.prototype.filter.call(element.querySelectorAll(focussableElements), o => o.offsetWidth > 0 || o.offsetHeight > 0);
    if (!focussable.length)
        return;
    const activeIndex = focussable.indexOf(document.activeElement);
    const lastIndex = focussable.length - 1;
    const previousIndex = activeIndex - 1 < 0 ? lastIndex : activeIndex - 1;
    const nextIndex = activeIndex + 1 > lastIndex ? 0 : activeIndex + 1;
    if (activeIndex === -1) {
        focussable[0]?.focus();
        return;
    }
    if (!isCyclic &&
        ((focusPrevious && previousIndex === lastIndex) || (!focusPrevious && nextIndex === 0))) {
        return;
    }
    if (focusPrevious) {
        focussable[previousIndex]?.focus();
    }
    else {
        focussable[nextIndex]?.focus();
    }
};
//# sourceMappingURL=moveFocus.js.map